module.exports = __webpack_public_path__ + "img/duck.0fd73869.svg";